<template>
  <div class="main2-content">
    <div class="panel-content">
      <div style="text-align: center">
        <div
            @click="utilHandleItsmDownload('./上汽大众2024ESG报告-中文版.pdf', '上汽大众2024年度ESG报告 SAIC VOLKSWAGEN ESG Report 2024')"
        >
            <img :src="require('../../assets/image/csr/imgs/iconDown@2x.png')"
              style="width: 16px; cursor: pointer;margin-bottom: 5.5px;" />
        </div>
        <div
            @click="utilHandleItsmDownload('./上汽大众2024ESG报告-中文版.pdf', '上汽大众2024年度ESG报告 SAIC VOLKSWAGEN ESG Report 2024')">
          了解更多详情，请下载企业ESG报告
        </div>
        <div
            @click="utilHandleItsmDownload('./上汽大众2024ESG报告-英文版.pdf', '上汽大众2024年度ESG报告 SAIC VOLKSWAGEN ESG Report 2024')">
          For more details, please download the SAIC VOLKSWAGEN ESG Report
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { csvw_url } from "../../components/config";
// import config from "./config1";
export default {
  components: {},
  data() {
    return {};
  },
  beforeMount() { },
  mounted() { },
  methods: {
    downloadChineseReport() {
      window.open("./上汽大众2023年度ESG报告.pdf", "_blank");
    },
    downloadEnglishReport() {
      window.open("./SAIC VOLKSWAGEN ESG Report 2023.pdf", "_blank");
    },
    download() {
      window.open("/u/cms/www/202012/07171926gFG5.pdf", "_target");
    },
    utilHandleItsmDownload(url, name) {
      console.log(111, url, name);
      let link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
    }
  },
};
</script>

<style lang="less" scoped>
@import url("./commonMobile.less");
// 描述字体颜色
@fontValue: #0077c8;

.main2-content {
  background: #fff;
  color: @fontValue;
  font-size: 11px;
  margin-top: 30px;
}

.panel-content {
  padding: 20px;
}
</style>
